import React, {useContext, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {Button, Grid, GridColumn, Modal, ModalCloser, ModalContent, ModalFooter, ModalHeader, TextField} from '../../../patterns';
import {StoreContext} from '../base/root-store';

export const CompanyDataApiSettingsModal = observer((): JSX.Element => {
    const store = useContext(StoreContext).companyStore;
    const existing = store.payload?.companyDataApiSettings;
    const [tenantId, setTenantId] = useState(existing?.tenantId || '');
    const [clientIds, setClientIds] = useState(Array.from(existing?.clientApplicationIds || []).join(', '));
    const [enabled, setEnabled] = useState(existing?.enabled ?? true);
    const clients = clientIds.split(',').map((value) => value.trim()).filter(Boolean);

    return <Modal size="small">
        <ModalHeader>
            <h4>Import data API Key</h4>
        </ModalHeader>
        <ModalContent>
            <p className="text">
                These settings apply only to the company-data API. They do not change Azure SSO, Teams, or any other connection. Do not enter a client secret.
            </p>
            <TextField
                label="Microsoft Entra tenant ID"
                value={tenantId}
                onChange={setTenantId}
                id="company-data-tenant-id"
                name="company-data-tenant-id"
            />
            <TextField
                label="Approved client application IDs (comma-separated)"
                value={clientIds}
                onChange={setClientIds}
                id="company-data-client-ids"
                name="company-data-client-ids"
            />
            <label style={{display: 'block', marginTop: '1rem'}}>
                <input type="checkbox" checked={enabled} onChange={(event): void => setEnabled(event.target.checked)} /> Enabled
            </label>
        </ModalContent>
        <ModalFooter>
            <Grid wrap={['xs']} justify={['between-xs']}>
                <GridColumn width={['xs-12', 'sm-6']}>
                    <ModalCloser>
                        <Button block={true} color="white" text={store.label('company.modal.cancel')} />
                    </ModalCloser>
                </GridColumn>
                <GridColumn width={['xs-12', 'sm-6']}>
                    {existing && <Button
                        block={true}
                        color="red"
                        text="Revoke"
                        onClick={(): void => {
                            if (window.confirm('Revoke company-data API access?')) {
                                void store.revokeCompanyDataApiSettings();
                            }
                        }}
                    />}
                    <Button
                        block={true}
                        color="green"
                        text={store.label('company.modal.save')}
                        disabled={!tenantId.trim() || clients.length === 0}
                        onClick={(): void => store.saveCompanyDataApiSettings({
                            tenantId: tenantId.trim(),
                            clientApplicationIds: clients,
                            enabled,
                        })}
                    />
                </GridColumn>
            </Grid>
        </ModalFooter>
    </Modal>;
});
